<template>
  <div class="content-item">
    
    <div class="content-top">
      <div class="content-top-left">
        <img :src="item.promotedProducts[0].imageUrl" alt="" class="image" />
        <!-- <LogoImage
          :logoUrl="item.promotedProducts[0].imageUrl"
          :brandName="item.promotedProducts[0].productTitle" :width="136" :height="136" :fontSize="8" :borderRadius="4" /> -->
      </div>
      <div class="content-top-right">
        <a-tooltip :title="isTitleOverflow ? item.promotedProducts[0].productTitle : ''" placement="topLeft">
          <div ref="titleRef" class="content-top-right-title" @mouseenter="checkTitleOverflow">
            {{ item.promotedProducts[0].productTitle }}
          </div>
        </a-tooltip>
        <div class="content-top-right-asin-stack">
          <AsinStack :record="record" :visibleCount="5" />
        </div>
      </div>
    </div>
    <div class="content-mid">
      <span class="content-mid-title">Brands:</span>
      <div class="item-box"> 
        <div v-for="(value, idx) in (item.brands || []).slice(0, 2)" :key="value.id || `${value.brandName}-${idx}`" class="item">
          <LogoImage
          :logoUrl="value.brandLogoUrl"
          :brandName="value.brandName" :width="20" :height="20" :fontSize="4"  />
        <!-- <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" /> -->
        <span class="item-text">{{value.brandName}}</span>
        </div>
       
      </div>
      <div class="more" v-if="(item.brands || []).length > 2">
        +{{ (item.brands || []).length - 2 }}
      </div>
    </div>
    <div class="status-text" v-if="item.status === 'ACTIVE'">
      <div class="circle">
        <div></div>
      </div>
      <span class="status-text-text">Active until {{ returnTime() }}</span>
    </div>
    <div class="content-bottom">
      <div class="content-bottom-item">
        <div class="content-bottom-item-title">
          EPC
        </div>
        <div class="content-bottom-item-content" >
          <div class="item">
            <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
            <span class="item-text">Attribution</span>
          </div>
          <div class="item-right">
            <span class="item-right-text"> {{ item.attributionCpcEnabled? CURRENCY_DATA_MAPPER[props.item.currency] + item.attributionCpcUnitPrice : 'N/A' }}</span>
          </div>
          <div ref="qrcodes" class="wenhaoPopover">
            <a-popover :get-popup-container="() => $refs.qrcodes" placement="top">
              <template #content>
                Attribution Links may generate additional CPS commissions on top of EPC earnings.
              </template>
              <svg class="icon lark" aria-hidden="true" >
                <use xlink:href="#icon-wenhao" />
              </svg>
            </a-popover>
          </div>
        </div>
        <div class="content-bottom-item-content">
          <div class="item">
            <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
            <span class="item-text">Associate</span>
          </div>
          <div class="item-right">
            <span class="item-right-text">{{ item.associateCpcEnabled? CURRENCY_DATA_MAPPER[props.item.currency] + item.associateCpcUnitPrice : 'N/A' }}</span>
          </div>
        </div>
        <div class="content-bottom-item-bottom">
          <div class="content-bottom-item-bottom-title">
            RemainingBudget:
          </div>
          <div class="content-bottom-item-bottom-content">
            {{CURRENCY_DATA_MAPPER[props.item.currency]}}{{ item.budgetRemaining }} 
            <!-- ( {{ item.publisherTotalCapClickEquivalent }} ) -->
          </div>
        </div>
      </div>
      <div class="content-bottom-item">
        <div ref="qrcodes" class="wenhaoPopoverBox">
          <div class="content-bottom-item-title">
          Budget Cap Rule:
          </div>
          <div ref="qrcodes" class="wenhaoPopover" >
            <a-popover
              placement="left"
              :get-popup-container="() => $refs.qrcodes"
              :overlay-inner-style="{ maxWidth: '500px' }"
            >
              <template #content>
                Budget caps apply only to CPC commissions. Attribution commissions and standard Amazon affiliate commissions (via Associate links) are not limited.
              </template>
              <svg class="icon lark" aria-hidden="true" >
                <use xlink:href="#icon-wenhao" />
              </svg>
            </a-popover>
          </div>
        </div>
        
        <div class="content-bottom-item-bottom">
          <div class="content-bottom-item-bottom-title">
           <span class="content-bottom-item-bottom-title-text">Total</span> Commission Limit
          </div>
          <div class="content-bottom-item-bottom-content">
           {{CURRENCY_DATA_MAPPER[props.item.currency]}}{{ item.publisherTotalCap }} 
           <!-- ( {{ item.publisherTotalCapClickEquivalent }} ) -->
          </div>
        </div>
        <div class="content-bottom-item-bottom">
          <div class="content-bottom-item-bottom-title">
            <span class="content-bottom-item-bottom-title-text">Daily</span> Commission Limit:
          </div>
          <div class="content-bottom-item-bottom-content">
            {{CURRENCY_DATA_MAPPER[props.item.currency]}}{{ item.publisherDailyCap }} 
            <!-- ( {{ item.publisherDailyCapClickEquivalent }} ) -->
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn">
      <artmisads-button type="primary" v-if="!item.joinedByMe" class="bottom-btn-btn" @click="joinCampaign">Join Campaign</artmisads-button>
      <artmisads-button class="bottom-btn-view" v-else @click="joinCampaign"> View Campaign Details</artmisads-button>
    </div>
  </div>
</template>

<script setup>
import { ref,watch } from 'vue'
import LogoImage from '@/components/LogoImage.vue'
import AsinStack from '@/components/AsinStack.vue'
import { useRouter } from 'vue-router'
import { COUNTRY_TIME_TZ,COUNTRY_SITE_CODE_MAP,CURRENCY_DATA_MAPPER } from '~/contants/common.js'
import moment from 'moment'
const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const timezone = COUNTRY_TIME_TZ[COUNTRY_SITE_CODE_MAP[props.item.marketplace] || 'US']

const titleRef = ref(null)
const isTitleOverflow = ref(false)
const record = ref({
  products: []
})
watch(() => props.item, (newVal) => {
  record.value.products = newVal.promotedProducts
  
}, { deep: true,immediate:true })
const router = useRouter()
const returnTime = () => {
  return moment(props.item.endDateTimestamp).tz(timezone).format('YYYY/MM/DD')
}
const joinCampaign = () => {
  router.push(
    `/publisher/campaigns/details/${props.item.id}?joinedByMe=${props.item.joinedByMe}`,
   
  )
}
// const campaignId = ref(route.params.id)
const checkTitleOverflow = () => {
  const el = titleRef.value
  if (!el) return
  isTitleOverflow.value = el.scrollHeight > el.clientHeight
}
</script>

<style scoped lang="less">
@flex: {
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-text {
  display: flex;
  align-items: center;
  gap: 6px;

  .status-text-text {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0%;
    color: rgba(42, 174, 103, 1);
  }
}

.circle {
  @flex();
  width: 12px;
  height: 12px;
  margin-right: 3px;
  border-radius: 50%;
  background: #C2E7D4;


  >div {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #2AAE67;
  }
}

.content-item {
  border: 1px solid rgba(232, 229, 237, 1);
  border-radius: 8px;
  padding: 16px 23px;

  .content-top {
    display: flex;
    gap: 12px;
    // align-items: center;
    justify-content: space-between;
    .image{
      width: 136px;
      height: 136px;
      object-fit: cover;
      border-radius: 4px;
    }

    .content-top-right {
      flex: 1;
      min-width: 0;

      .content-top-right-title {
        display: -webkit-box;
        line-clamp: 4;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        font-family: Sora;
        font-weight: 400;
        font-style: Regular;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 18px;
        letter-spacing: 0.3px;
        color: rgba(0, 0, 0, 1);
      }

      .content-top-right-asin-stack {
        margin-top: 12px;
      }
    }
  }

  .content-mid {
    display: flex;
    gap: 6px;
    align-items: center;
    padding: 16px 0;

    .content-mid-title {
      font-family: Sora;
      font-weight: 400;
      font-size: 13px;
      leading-trim: NONE;
      line-height: 18px;
      letter-spacing: 0.3px;
      color: rgba(15, 6, 41, 0.7);
    }
    .item-box{
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .item {
      display: flex;
      padding: 3px 4px;
      align-items: center;
      gap: 6px;
      border-radius: 6px;
      background: #f1f0f5;
      min-width: 111px;

      .icon {
        width: 20px !important;
        height: 20px !important;
      }

      .item-text {
        color: #0f0629;
        font-family: 'Sora';
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        letter-spacing: 0.3px;
        opacity: 0.7;
      }
    }

    .more {
      background: #f1f0f5;
      width: 30px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      font-family: Sora;
      font-weight: 400;
      font-style: Regular;
      font-size: 13px;
      leading-trim: NONE;
      line-height: 22px;
      letter-spacing: 0%;
      color: rgba(15, 6, 41, 0.7);
    }
  }
}
.wenhaoPopover{
  display: flex;
  align-items: center;
  justify-content: center;
}
.wenhaoPopoverBox{
  display: flex;
  align-items: center;
  gap: 4px;

}
.content-bottom {
  display: flex;
  gap: 12px;
  margin-top: 16px;

  .content-bottom-item {
    flex: 1;
    background: rgba(248, 247, 252, 1);
    padding: 12px;
    border-radius: 8px;

    .content-bottom-item-title {
      font-family: Sora;
      font-weight: 500;
      font-size: 13px;
      leading-trim: NONE;
      line-height: 18px;
      letter-spacing: 0.3px;
      color: rgba(15, 6, 41, 0.9);
    }

    .content-bottom-item-content {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-top: 10px;

      .item {
        display: flex;
        padding: 3px 4px;
        align-items: center;
        gap: 6px;
        border-radius: 6px;
        background: #f1f0f5;
        min-width: 111px;

        .icon {
          width: 20px !important;
          height: 20px !important;
        }

        .item-text {
          color: #0f0629;
          font-family: 'Sora';
          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          letter-spacing: 0.3px;
          opacity: 0.7;
        }
      }

      .item-right {
        border: 1px solid rgba(242, 85, 68, 0.4);
        background-color: rgba(242, 85, 68, 0.1);
        border-radius: 4px;
        color: rgba(235, 78, 61, 1);
        font-family: Sora;
        font-weight: 500;
        font-style: Medium;
        font-size: 12px;
        leading-trim: NONE;
        line-height: 16px;
        letter-spacing: 0.3px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        .item-right-text {
          padding: 4px;
        }
      }
    }

    .content-bottom-item-bottom {
      margin-top: 8px;

      .content-bottom-item-bottom-title {
        font-family: Sora;
        font-weight: 400;
        font-style: Regular;
        font-size: 13px;
        leading-trim: NONE;
        line-height: 20px;
        letter-spacing: 0.4px;
        color: rgba(15, 6, 41, 0.7);
      }
      .content-bottom-item-bottom-title-text{
       color: rgba(108, 61, 242, 1);
      }
      .content-bottom-item-bottom-content {
        font-family: Sora;
        font-weight: 500;
        font-style: Regular;
        font-size: 13px;
        leading-trim: NONE;
        line-height: 20px;
        letter-spacing: 0.4px;
        color: rgba(15, 6, 41, 0.9);
      }
    }
  }
}
.bottom-btn{
  margin-top: 16px;
  .bottom-btn-btn{
    width: 100%;
  }
  .bottom-btn-view{
    width: 100% !important;
    border: 1px solid rgba(138, 100, 244, 1) !important;
    background-color:linear-gradient(0deg, var(--Brand-Primary_weaker, rgba(138, 100, 244, 0.14)), var(--Brand-Primary_weaker, rgba(138, 100, 244, 0.14))),
linear-gradient(0deg, #EFEAFC, #EFEAFC) !important;
color: rgba(108, 61, 242, 1) !important ;  
}
}
</style>